(function(){
var f=document.getElementById('vxg');if(!f)return;
var POR='40110074',FRM='0e006f71-2813-48f4-9896-e2c77aa18118';
var ok=document.querySelector('[data-vxok]'),erro=f.querySelector('[data-vxg-erro]'),bt=f.querySelector('.vxg__enviar');
f.addEventListener('change',function(e){
 var i=e.target;if(!i.classList||!i.classList.contains('vxg__fi'))return;
 var n=i.parentElement.querySelector('.vxg__fn');
 n.textContent=i.files&&i.files.length?i.files[0].name:'Nenhum arquivo escolhido';
});
function fecha(){ok.setAttribute('hidden','');document.body.style.overflow=''}
document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-vxok-fecha]'))fecha()});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!ok.hidden)fecha()});
f.addEventListener('submit',function(e){
 e.preventDefault();
 erro.hidden=true;
 if(!f.reportValidity())return;
 bt.disabled=true;bt.textContent='Enviando…';
 var d=new FormData();
 [].forEach.call(f.elements,function(el){
  if(!el.name)return;
  if(el.type==='checkbox'){d.append(el.name,el.checked?'true':'false');return}
  if(el.type==='file'){if(el.files&&el.files.length)d.append(el.name,el.files[0]);return}
  if(el.value!=='')d.append(el.name,el.value);
 });
 d.append('hs_context',JSON.stringify({pageUrl:location.href,pageName:document.title,hutk:(document.cookie.match(/hubspotutk=([^;]+)/)||[])[1]||''}));
 fetch('https://forms.hubspot.com/uploads/form/v2/'+POR+'/'+FRM,{method:'POST',body:d})
 .then(function(r){
  if(!r.ok)throw new Error(r.status);
  f.reset();
  [].forEach.call(f.querySelectorAll('.vxg__fn'),function(n){n.textContent='Nenhum arquivo escolhido'});
  ok.removeAttribute('hidden');document.body.style.overflow='hidden';
  var b=ok.querySelector('.vxok__b');if(b)b.focus();
 })
 .catch(function(){
  erro.textContent='Não conseguimos enviar agora. Tente de novo, ou chame a Voxel no WhatsApp.';
  erro.hidden=false;
 })
 .finally(function(){bt.disabled=false;bt.textContent='Enviar solicitação'});
});
})();
